import React from "react";
import pluralize from "pluralize";
import LinkedTeamsPopoverContent from "../components/LinkedTeamsPopoverContent";

const getLinkedTeamsCount = (objective, _rawObjectives, associatedTeams) => {
  const teams = (associatedTeams || []).filter((team) =>
    team.objectiveIds?.includes(objective?.id)
  );
  const teamCount = teams?.length || 0;

  if (teamCount === 0) {
    return null;
  }

  return {
    id: "linkedTeams",
    icon: ["fas", "users"],
    label: `${teamCount} ${pluralize("Team", teamCount)}`,
    popoverContent: <LinkedTeamsPopoverContent teams={teams} />,
  };
};

export default getLinkedTeamsCount;
